import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_REVENUE_DATA } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError, notifySuccess } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

let defaultYear = new Date().getFullYear()

function getDefaultRevenueLogItems (year) {
  return [
    { id: null, year: year, month: 1, revenue: 0 },
    { id: null, year: year, month: 2, revenue: 0 },
    { id: null, year: year, month: 3, revenue: 0 },
    { id: null, year: year, month: 4, revenue: 0 },
    { id: null, year: year, month: 5, revenue: 0 },
    { id: null, year: year, month: 6, revenue: 0 },
    { id: null, year: year, month: 7, revenue: 0 },
    { id: null, year: year, month: 8, revenue: 0 },
    { id: null, year: year, month: 9, revenue: 0 },
    { id: null, year: year, month: 10, revenue: 0 },
    { id: null, year: year, month: 11, revenue: 0 },
    { id: null, year: year, month: 12, revenue: 0 }
  ]
}

const revenueData = {
  namespaced: true,
  state: buildInitialState({
    year: defaultYear,
    goalData: {
      year: defaultYear,
      goal: 0
    },
    revenueLogItems: getDefaultRevenueLogItems(defaultYear)
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setRevenueData: (state, data) => {
      state.year = data.year
      state.goalData = data.goalData
      state.revenueLogItems = data.revenueLogItems && data.revenueLogItems.length > 0 ? data.revenueLogItems : getDefaultRevenueLogItems(data.year)
    },
    clearRevenueData (state) {
      state.year = defaultYear
      state.goalData = {
        year: defaultYear,
        goal: 0
      }
      state.revenueLogItems = [
        { id: null, year: defaultYear, month: 1, revenue: 0 },
        { id: null, year: defaultYear, month: 2, revenue: 0 },
        { id: null, year: defaultYear, month: 3, revenue: 0 },
        { id: null, year: defaultYear, month: 4, revenue: 0 },
        { id: null, year: defaultYear, month: 5, revenue: 0 },
        { id: null, year: defaultYear, month: 6, revenue: 0 },
        { id: null, year: defaultYear, month: 7, revenue: 0 },
        { id: null, year: defaultYear, month: 8, revenue: 0 },
        { id: null, year: defaultYear, month: 9, revenue: 0 },
        { id: null, year: defaultYear, month: 10, revenue: 0 },
        { id: null, year: defaultYear, month: 11, revenue: 0 },
        { id: null, year: defaultYear, month: 12, revenue: 0 }
      ]
    }
  },
  actions: {
    getRevenueData: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting revenue data, please wait...' })

      return api.doGet({ path: PATH_REVENUE_DATA, parameters: { Year: state.year } })
        .then(json => json.data)
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setRevenueData', data)
          return data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          commit('clearRevenueData')
          notifyError(dispatch, 'Unable to select revenue data')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveRevenueData: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving revenue data, please wait...' })

      return api.doPost({ path: PATH_REVENUE_DATA, data: state })
        .then(response => {
          commit('updateStatus', { status: COMPLETE })

          if (!response.data) {
            throw new Error('Unable to save revenue data.')
          }

          notifySuccess(dispatch, 'Revenue data saved')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save revenue data')

          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default revenueData
